import { createRoot } from "react-dom/client";
import { Sidebar } from "../components/Sidebar";

export const initSidebar = () => {
  const sidebarContainer = document.getElementById("sidebar");

  if (sidebarContainer) {
    const root = createRoot(sidebarContainer);
    const { logoutPath, userName, logoPath, logoPathCollapsed, canCreateCase, newCasePath, navItems, userMenuItems } =
      sidebarContainer.dataset;

    root.render(
      <Sidebar
        logoutPath={logoutPath}
        userName={userName}
        logoPath={logoPath}
        canCreateCase={canCreateCase === "true"}
        newCasePath={newCasePath}
        logoPathCollapsed={logoPathCollapsed}
        userMenuItems={JSON.parse(userMenuItems)}
        navItems={JSON.parse(navItems)}
      />
    );
  }
};
